import { FunctionComponent, useMemo } from 'react';
import {
  StyledHeading1,
  StyledHeading2,
  StyledHeading3,
  StyledHeading4,
  StyledHeading5,
  StyledHeading6,
} from './Heading.styled';
import { HeadingProps } from './types';

export const Heading: FunctionComponent<HeadingProps> = props => {
  const { children, size, ...rest } = props;

  // Select the appropriate heading component for the specified size
  const Component = useMemo(() => {
    switch (size) {
      case 6:
        return StyledHeading6;
      case 5:
        return StyledHeading5;
      case 4:
        return StyledHeading4;
      case 3:
        return StyledHeading3;
      case 2:
        return StyledHeading2;
      case 1:
      default:
        return StyledHeading1;
    }
  }, [size]);

  return <Component {...rest}>{children}</Component>;
};
